import getUrlByRole from "./getUrlByRole";
const getStockStatusesForOptions = (options, isConfigurableProduct) => {
    return options.map((option) => ({
        key: isConfigurableProduct ? option?.product?.sku : option.id,
        value: option?.product?.stock_status,
    }));
};
const getGalleryOptions = (productData, callback /* TODO: fix me */) => productData?.items
    ?.map((item) => callback(item?.all_options))
    .reduce((prev, option) => ({
    ...prev,
    ...option,
}), {});
export const getStockStatusesForBundleItems = (productData) => {
    const productType = productData?.__typename;
    const isConfigurableProduct = productType === "ConfigurableProduct";
    const getStockStatuses = (items) => {
        return items?.reduce((accumulatedStatuses, item) => {
            const stockStatuses = getStockStatusesForOptions(item?.all_options ?? [], isConfigurableProduct);
            const stockStatusesObject = stockStatuses?.reduce((statusMap, { key, value }) => ({
                ...statusMap,
                [key]: value,
            }), {});
            return {
                ...accumulatedStatuses,
                ...stockStatusesObject,
            };
        }, {});
    };
    return getStockStatuses(productData.items ?? []);
};
export default function getOptions(productData, getType) {
    const productType = productData?.__typename;
    const isConfigurableProduct = productType === "ConfigurableProduct";
    const callback = (array) => array?.reduce((prev, option) => ({
        ...prev,
        [isConfigurableProduct ? option?.product?.sku : option.id]: getType === "gallery" ? getUrlByRole(option?.product?.media_gallery) : option?.product?.stock_status,
    }), {});
    if (isConfigurableProduct) {
        return getType === "gallery" ? {} : callback(productData?.variants);
    }
    return getType === "gallery" ? getGalleryOptions(productData, callback) : getStockStatusesForBundleItems(productData);
}
//# sourceMappingURL=getOptions.js.map